<template>
  <div>
    <vxe-grid
      ref="techTable"
      auto-resize
      resizable
      highlight-hover-row
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :data="tableData"
      :columns="tableColumns"
      :height="500"
      size="mini"
      border
      :edit-config="{ enabled: true, trigger: 'click', mode: 'row' }"
      @edit-closed="editClosed"
      :edit-rules="rules"
      show-footer
      :footer-method="() => footerData()"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
        >
          <i class="el-icon-delete tool-btn" @click="$emit('remove', row)"></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import {
  format,
  multiplyRound,
  multiply,
  divideRound,
  divide,
  add,
} from '@/libs/util.number.js'
export default {
  props: { tableData: { type: Array, default: () => [] } },
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          fixed: 'left',
          width: 70,
          slots: { default: 'opt' },
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_tech_pdProcessDictStep') || '工序',
          field: 'processName',
          width: 100,
          fixed: 'left',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_tech_techName') || '工艺',
          field: 'techName',
          minWidth: 150,
          align: 'left',
          fixed: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_tech_techChargeUnit') || '单位',
          field: 'techChargeUnit',
          width: 100,
          align: 'center',
          editRender: {
            name: 'dict-select',
            props: {
              url: '/master/common/dict/biz',
              body: { dictType: 'techChargeUnit' },
              filterable: true,
              clearable: true,
              size: 'mini',
            },
          },
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_tech_laborCost') || '工费(元/H)',
          field: 'laborCost',
          align: 'center',
          width: 100,
          editRender: {
            name: 'ElInputNumber',
            props: {
              precision: 2,
              min: 0,
              max: 9999.99,
              controls: false,
            },
          },
          formatter: ({ row }) => {
            const { laborCost: value } = row
            return format(value)
          },
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_tech_workforce') || '作业人数',
          field: 'workforce',
          align: 'center',
          width: 100,
          editRender: {
            name: 'ElInputNumber',
            props: {
              min: 0,
              max: 9999999999,
              precision: 0,
              controls: false,
            },
          },
          formatter: ({ row }) => {
            const { workforce: value } = row
            return format(value)
          },
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_tech_processDuration') || '工序耗时(s)',
          field: 'processDuration',
          align: 'center',
          width: 100,
          editRender: {
            name: 'ElInputNumber',
            props: {
              min: 0,
              max: 999999.99,
              precision: 2,
              controls: false,
            },
          },
          formatter: ({ row }) => {
            const { processDuration: value } = row
            return format(value)
          },
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_tech_capacity') || '产能/H',
          field: 'capacity',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },

        {
          title: this.$l('table_label_tech_laborPrice') || '工价',
          field: 'laborPrice',
          align: 'center',
          width: 100,
          formatter: ({ row }) => {
            const { laborPrice: value } = row
            return format(value)
          },
          showHeaderOverflow: true,
          isTotalColumn: true,
        },
        {
          title: this.$l('table_label_tech_techDesc') || '备注说明',
          field: 'techDesc',
          minWidth: 200,
          headerAlign: 'center',
          align: 'left',
          editRender: {
            name: 'ElInput',
            props: {
              clearable: true,
            },
          },
          showHeaderOverflow: true,
        },
      ],
      rules: {
        techChargeUnit: [
          {
            required: true,
            message:
              this.$l('table_label_tech_pl_techChargeUnit') || '请选择单位...',
          },
        ],
        laborCost: [
          {
            type: 'number',
            required: true,
            message:
              this.$l('table_label_tech_pl_laborCost') || '请输入工费(元/H)...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        workforce: [
          {
            type: 'number',
            required: true,
            message:
              this.$l('table_label_tech_pl_workforce') || '请输入作业人数...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        processDuration: [
          {
            type: 'number',
            required: true,
            message:
              this.$l('table_label_tech_pl_processDuration') ||
              '请输入工序耗时(s)...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
      },
    }
  },
  methods: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)
      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))
      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => totalColumnValues[t.field] || '')
      result[2] = this.$l('INDEX.total') || '合计'
      return [result]
    },
    editClosed({ row }) {
      const { processDuration, laborCost, workforce } = row
      //processDuration 工序耗时 laborCost 工费  capacity 产能  laborPrice 工价
      if (!processDuration) {
        row.capacity = 0
        row.laborPrice = 0
        return
      }
      row.capacity = divideRound(3600, processDuration, 0)
      row.laborPrice = multiplyRound(
        multiply(divide(laborCost, 3600), workforce),
        processDuration,
        3
      )
      this.$refs.techTable.updateFooter()
    },
    // async sort(sortConfs, order) {
    //   await this.$refs.techTable.sort(sortConfs, order)
    // },
    async validate() {
      return !(await this.$refs.techTable.validate(true))
    },
    async getTableData() {
      const { tableData } = this.$refs.techTable.getTableData()
      return tableData || []
    },
  },
}
</script>
